import { Card } from "@radix-ui/themes";
import PropTypes from "prop-types";

BottomLeftMapDiv.propTypes = {
  children: PropTypes.node,
};

export default function BottomLeftMapDiv({ children }) {
  return (
    <Card
      id="bottom-left-map-div"
      style={{
        position: "absolute",
        bottom: 20,
        left: 20,
        zIndex: 1000,
        backgroundColor: "white",
        borderRadius: "var(--radius-4)",
        maxWidth: "250px",
        maxHeight: "200px",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      }}
    >
      {children}
    </Card>
  );
}
